export enum ValueIsPropertyOperators {
    CollectionEmpty = "collection_empty",
    CollectionNotEmpty = "collection_not_empty",
    ValueString = "value_string",
    OneOf = "one_of",
    NotValueString = "not_value_string",
    NotOneOf = "not_one_of",
    Undefined = "undefined",
    Defined = "defined",
    False = "false",
    True = "true"
}